import { Button, IconButton, Typography } from "@material-ui/core";
import DownloadIcon from "@material-ui/icons/CloudDownload";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { decryptData } from "../../../../crypto";
import useStyles from "../../../../styles";
import QuestionHead from "../../../CustomComponent/QuestionHead";
import ResultHead from "../../../CustomComponent/ResultHead1";
import Loader from "../../../CustomComponent/Loader";
import TableView from "../../../CustomComponent/TableView";
import { ReactComponent as ResultIcon } from "../../../images/questionimage/resulticon.svg";

function ExamResult() {
  const classes = useStyles();
  const { rowId } = useParams();
  const decryptedToken = decryptData(sessionStorage.getItem("token"));
  const [searchQuery, setSearchQuery] = useState("");
  const [results, setResults] = useState([]);
  const [fileURL, setFileURL] = useState("");
  const navigate = useNavigate();
  const params = useParams();

  const [pageSize, setPageSize] = useState(25);
  const [onPage, setOnPage] = useState(0);
  const [rowCount, setRowCount] = useState("");
  const [page, setPage] = useState(0);
  const [rows, setRows] = useState([]);

  const [examDetails, setExamDetails] = useState({
    examName: "",
    courseName: "",
    batchName: "",
    subjectNames: "",
    examImage: "",
  });

  useEffect(() => {
    const fetchExamData = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/exam/${rowId}`,
          {
            headers: {
              Authorization: `Bearer ${decryptedToken}`,
            },
          },
        );

        const exam = response.data.exam;
        // const subjectNames = exam.subjects
        //   .map((sub) => sub.subject_name)
        //   .join(", ");

        setExamDetails({
          examName: exam.exam_name,
          // courseName: exam.course.course_name,
          // batchName: exam.batch.batch_name,
          // subjectNames: subjectNames,
          // examImage: exam.image_url,
        });
      } catch (error) {
        console.error("Error fetching exam data: ", error);
      }
    };

    fetchExamData();
  }, [rowId, decryptedToken]);

  const fetchData = async (rowId, pageNumber, size, search) => {
    if (!Number.isFinite(pageNumber) || !Number.isFinite(size)) return;

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/v1/client/upload/scan/result/all/${rowId}?page=${pageNumber + 1}&limit=${size}&search=${search}`,
        {
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
          },
        },
      );

      setResults(response.data.results);
      setRowCount(response.data.totalCount);
    } catch (error) {
      console.error("Error fetching data: ", error);
    }
  };
 
  useEffect(() => {
      if (
        onPage !== undefined &&
        pageSize !== undefined &&
        searchQuery !== undefined
      ) {
        fetchData(rowId,onPage, pageSize, searchQuery);
      }
    }, [onPage, pageSize, searchQuery,rowId]);

     const handlePageChange = (newPage) => {
    setPage(newPage);
    setOnPage(newPage); // Pass newSelection directly
  };


useEffect(() => {
  const startIndex = onPage * pageSize;

  const mappedRows = results.map((d) => ({
    id: d.roll_number ? d.roll_number : "N/A",
    learner_name: d.learner_name ? d.learner_name : "N/A",
    exam_name: d.exam_name ? d.exam_name : "N/A",
    roll_number: d.roll_number ? d.roll_number : "N/A",
    correct: d.correct ? d.correct : "0",
    incorrect: d.incorrect ? d.incorrect : "0",
    received_marks: d.received_marks ? d.received_marks : "0",
    not_answer: d.not_answer ? d.not_answer : "0",
    branch_name: d.branch_name ? d.branch_name : "N/A",
    // result_status: d.result_status ? d.result_status : "N/A",
    // total_score: d.total_score ? d.total_score : "N/A",
    // total_questions: d.total_questions ? d.total_questions : "N/A",
    // active_status: d.active_status ? d.active_status : "N/A",
  }));

  const finalRows = mappedRows.map((row, index) => ({
    ...row,
    srno: startIndex + index + 1,
  }));

  setRows(finalRows);
}, [results, searchQuery, onPage, pageSize]);

  const style = [
    {
      style: "viewtable",
      height: "maxh67",
      footer: false,
      setPageSize: setPageSize,
      pageSize: pageSize,
      rowCount: rowCount,
      handlePageChange: handlePageChange,
      page: page,
      paginationMode: "server",
    },
  ];

  const navigateToAnswer = async (userId, student_name, roll_number) => {
    // console.log("userId------------",userId);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/v1/client/upload/result/one/${roll_number}`,
        {
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
          },
        },
      );
      console.log(response);
      if (response.data.success === true) {
        const examResult = response.data.data;
        navigate(`/admin/examresult/${params.rowId}/examscore`, {
          state: {
            examResult: JSON.stringify(examResult),
          },
        });
      }
    } catch (error) {
      console.error("Error fetching data: ", error);
    }
  };


  const handleSearch = (query) => {
    setSearchQuery(query);
  };

  const Result = [
    {
      id: 1,
      pageicon: <ResultIcon />,
      mainheading: "Students Results",
      searchlabel: "Search By Student Name",
      placeholder: "Search By Class",
      style: "viewtable",
      height: "h61vh",
      result: "result",
    },
  ];

  const columns = [
    {
      field: "srno",
      headerName: "Sr.No",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 70,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
    },
    {
      field: "roll_number",
      headerName: "Roll Number",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 200,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
    },
    {
      field: "learner_name",
      headerName: "Learner Name",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 200,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
    },
    {
      field: "branch_name",
      headerName: "Branch Name",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 200,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
    },
    {
      field: "exam_name",
      headerName: "Exam Name",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 200,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
    },
    {
      field: "correct",
      headerName: "Correct Answer",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 180,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
    },
    {
      field: "incorrect",
      headerName: "Incorrect Answer",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 180,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
    },
    // {
    //   field: "not_answer",
    //   headerName: "Not Answered",
    //   headerClassName: "super-app-theme--header",
    //   headerAlign: "center",
    //   width: 180,
    //   flex: 1,
    //   sortable: false,
    //   disableColumnMenu: true,
    //   autoPageSize: false,
    // },
    {
      field: "received_marks",
      headerName: "Received Marks",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 180,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
    },
    // {
    //   field: "percentage",
    //   headerName: "Percentage",
    //   headerClassName: "super-app-theme--header",
    //   headerAlign: "center",
    //   width: 180,
    //   flex: 1,
    //   sortable: false,
    //   disableColumnMenu: true,
    //   autoPageSize: false,
    // },
    // {
    //   field: "result_status",
    //   headerName: "Result Status",
    //   headerClassName: "super-app-theme--header",
    //   headerAlign: "center",
    //   width: 180,
    //   flex: 1,
    //   sortable: false,
    //   disableColumnMenu: true,
    //   autoPageSize: false,
    // },
    {
      field: "active_status",
      headerName: "View Result",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      sortable: false,
      disableColumnMenu: true,
      width: 100,
      autoPageSize: false,
      renderCell: (params) => {
        {
          console.log("params", params);
        }
        return (
          <div style={{ display: "flex", alignItems: "center" }}>
            <Button
              startIcon={<DownloadIcon color="success" />}
              onClick={() =>
                navigateToAnswer(
                  params.row.user_id,
                  params.row.student_name,
                  params.row.roll_number,
                )
              }
            />
          </div>
        );
      },
    },
  ];

  const Heading = [
    {
      id: 1,
      logo: examDetails.examImage,
      path: "/admin/exam",
      headings: [
        {
          id: 11,
          label: "Name",
          content: examDetails.examName,
        },
        // {
        //   id: 12,
        //   label: "Subject",
        //   content: examDetails.subjectNames,
        // },
        // {
        //   id: 13,
        //   label: "Course",
        //   content: examDetails.courseName,
        // },
        // {
        //   id: 14,
        //   label: "Batch",
        //   content: examDetails.batchName,
        // },
      ],
    },
  ];

  const [loaderOpen, setLoaderOpen] = useState(false);

  return (
    <>
      <ToastContainer />
      <div className={`${classes.p2} ${classes.pb0} ${classes.pt1}`}>
        <QuestionHead Heading={Heading} />
        <div className={`${classes.mt1}`}>
          <Loader loaderOpen={loaderOpen} />
          <ResultHead
            result={true}
            rowId={rowId}
            decryptedToken={decryptedToken}
            onSearch={handleSearch}
            Heading={Result}
            setLoaderOpen={setLoaderOpen}
          />
          <TableView columns={columns} rows={rows} Heading={style} />
        </div>
      </div>
    </>
  );
}
export default ExamResult;
